declare var gtag: Function;

export function trackDialogView(dialogName: string) {
	// Don't track dialog views in development
	if (window.location.hostname === 'localhost') {
		console.log('Dialog view tracking disabled in development');
		return;
	}

	gtag('event', 'dialog_view', {
		dialog_name: dialogName,
		page_location: window.location.pathname,
	});
}
